import ReactQuill from 'react-quill';
import { useFormContext } from 'react-hook-form';

import Input from '@/components/common/Input';

const modules = {
	toolbar: [
		[{ header: [1, 2, false] }],
		['bold', 'italic', 'underline', 'strike', 'blockquote'],
		[
			{ list: 'ordered' },
			{ list: 'bullet' },
			{ indent: '-1' },
			{ indent: '+1' },
		],
		['link', 'image'],
		['clean'],
	],
};

const formats = [
	'header',
	'bold',
	'italic',
	'underline',
	'strike',
	'blockquote',
	'list',
	'bullet',
	'indent',
	'link',
	'image',
];

const LeftSection = () => {
	const form = useFormContext();
	return (
		<>
			<div>
				<div className="program-detail-card">
					<Input
						className="text-jb-3xl p-7"
						expanded
						name="title"
						type="text"
						placeholder="Enter news title ..."
						{...form.register('title')}
					/>
				</div>
				<div className="flex p-5 items-center pt-4 bg-white border border-grey-soft">
					<span className="mr-2">https://jayaprana.id/news</span>
					<Input
						name="slug"
						type="text"
						placeholder="Input"
						onChange={() => {}}
						{...form.register('slug')}
					/>
				</div>
			</div>
			<div className="bg-white mt-4 p-4 border border-grey-soft">
				<ReactQuill
					formats={formats}
					modules={modules}
					value={form.watch('content')}
					onChange={(v) => form.setValue('content', v)}
				/>
			</div>
		</>
	);
};
export default LeftSection;
